import { render, staticRenderFns } from "./RejectedTicketsList.vue?vue&type=template&id=62fc879a"
import script from "./RejectedTicketsList.vue?vue&type=script&lang=js"
export * from "./RejectedTicketsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports